import * as R from 'ramda'
import { connect } from 'react-redux'

import * as casino from '@rushplay/casino'
import * as session from '@rushplay/session'
import { withTranslate } from '@rushplay/i18n'

import { LobbyLiveGameTile as Component } from './lobby-live-game-tile'

function mapStateToProps(state, props) {
  return {
    authenticated: session.isSessionActive(state.session),
    game: casino.selectors.getGame(state.casino, props),
  }
}

const connector = R.compose(connect(mapStateToProps), withTranslate)

export const LobbyLiveGameTile = connector(Component)
